/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * * `date_delivery` - date_delivery * `date_kill` - date_kill * `date_transport` - date_transport * `type` - type * `product` - product
 * @export
 * @enum {string}
 */
export enum SellerDataRequestSettingsPropertiesSystemEnum {
    DateDelivery = 'date_delivery',
    DateKill = 'date_kill',
    DateTransport = 'date_transport',
    Type = 'type',
    Product = 'product'
}



